<template>
  <Accordion
    v-if="useAccordion && fieldsets"
    type="multiple"
    collapsible
    v-model="openItems"
  >
    <div class="flex flex-col gap-y-4">
      <template v-for="fieldset in fieldsets" :key="fieldset.label">
        <AccordionItem
          :value="`item-${fieldset.label}`"
          class="w-auto rounded-md border-none bg-background px-4 pb-2"
        >
          <AccordionTrigger>
            <span class="text-sm">{{ fieldset.label }}</span>
          </AccordionTrigger>
          <AccordionContent class="">
            <FormSet :fields="fieldset.fields" />
          </AccordionContent>
        </AccordionItem>
      </template>
    </div>
  </Accordion>
  <div class="w-full space-y-6" v-else>
    <template v-for="(fieldset, i) in fieldsets" :key="i">
      <div>
        <div v-if="fieldset.label" :class="formItemClasses">
          <div :class="labelClasses"></div>
          <div class="w-full font-bold">{{ fieldset.label }}</div>
        </div>
        <FormSet :fields="fieldset.fields" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';

interface Fieldset {
  label?: string;
  fields: any[];
}

const props = defineProps<{
  fieldsets: Fieldset[];
  useAccordion?: boolean;
}>();

const formItemClasses = 'flex';
const labelClasses = ['text-right', 'pr-4', 'mt-5', 'w-[200px]', 'opacity-80'];

const openItems = ref(props.fieldsets.map((f) => `item-${f.label}`));

watch(
  () => props.fieldsets,
  (newFieldsets) => {
    openItems.value = newFieldsets.map((f) => `item-${f.label}`);
  },
  { immediate: true },
);
</script>
